import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
// Использован recompose, потому, что recompact не дружит с хуками
import { withHandlers, withStateHandlers } from "recompose"
import { compose, withProps } from "recompact"
import moment from "moment"
import {
  addEvent,
  initCalendar,
  loadCalendar,
  removeEvent,
  selectCalendarData,
  selectCalendarMeta,
  updateEvent,
} from "src/engine/modules/calendar"
import { usePrevious, useQueryState } from "src/hooks"
import isEmpty from "lodash/isEmpty"
import get from "lodash/get"
import hocInterface from "src/helpers/hocInterface"
import trim from "lodash/trim"
import { DEFAULT_PAGE_HEIGHT, SCALE_CODES } from "../constants"

export const ORDER_ASC = `name asc`
export const ORDER_DESC = `name desc`

const resourceTypeIdToQuery = resourceTypeId => {
  if (isEmpty(resourceTypeId)) {
    return []
  }
  const arrayOfId = resourceTypeId.map(item => item.value || item)
  return [`resourceTypeId=in=(${arrayOfId.join(`,`)})`]
}

const nameQueryToValue = resourceQuery => {
  const nameRegex = /;?name==\*(?<name>.*)?\*/gi
  const resultObj = nameRegex.exec(resourceQuery)
  return get(resultObj, `groups.name`, ``)
}

// find resource type in query
const typeQueryToValue = resourceQuery => {
  // TODO: HELL CRUTCH
  const regexp = /resourceTypeId=in=\((.+?)\)/g
  const findResourceTypeId = resourceQuery && resourceQuery.match(regexp)
  if (findResourceTypeId && findResourceTypeId[0]) {
    return findResourceTypeId[0]
      .slice(19, findResourceTypeId[0].length - 1)
      .split(`,`)
      .map(item => Number(item))
  }
  return null
}

const eventToQuery = eventTypeId => {
  if (!eventTypeId || isEmpty(eventTypeId)) {
    return []
  }
  const arrayOfId = eventTypeId
    .filter(item => !!item)
    .map(item => item.value || item)
  return [`eventTypeId=in=(${arrayOfId.join(`,`)})`]
}

// convert event status values to query
const statusToQuery = eventStatusCode => {
  if (!eventStatusCode || isEmpty(eventStatusCode)) {
    return []
  }
  const arrayOfCode = eventStatusCode
    .filter(item => !!item)
    .map(item => item.value || item)
  return [`statusCode=in=(${arrayOfCode.join(`,`)})`]
}

const resourceNameToQuery = name => {
  if (!name) {
    return []
  }
  const nameQuery =
    name.slice(-1) === `*` ? `name==*${name}` : `name==*${name}*`

  return [nameQuery]
}

const valueFromFilter = filter => {
  if (!filter) {
    return null
  }

  const resourceTypeIdRegex = /;?resourceTypeId=in=\((?<resourceTypeId>\S+)\);?/gi
  return trim(
    get(resourceTypeIdRegex.exec(filter), `groups.resourceTypeId`, ``),
    `;`,
  )
    .split(`,`)
    .map(item => parseInt(item, 10))
}

const eventTypeQueryToValue = eventQuery => {
  // TODO: HELL CRUTCH PRT.2
  const regexp = /eventTypeId=in=\((.+?)\)/g
  const findEventTypeId = eventQuery && eventQuery.match(regexp)
  if (findEventTypeId && findEventTypeId[0]) {
    return findEventTypeId[0]
      .slice(16, findEventTypeId[0].length - 1)
      .split(`,`)
      .map(item => Number(item))
  }

  return null
}

// Search by custom field
const eventCustomFieldQueryToValue = eventQuery => {
  const nameRegex = /;?customField=='\*(?<field>.*)?\*'/gi
  const resultObj = nameRegex.exec(eventQuery)
  return get(resultObj, `groups.field`, null)
}

const eventCustomFieldToQuery = field => {
  if (!field) {
    return null
  }
  const nameQuery =
    field.slice(-1) === `'`
      ? `customField=='*${field}*`
      : `customField=='*${field}*'`
  return [nameQuery]
}

const statusCodeQueryToValue = statusQuery => {
  // TODO: HELL CRUTCH PRT.4
  const regexp = /statusCode=in=\((.+?)\)/g
  const findStatusCodeId = statusQuery && statusQuery.match(regexp)
  if (findStatusCodeId && findStatusCodeId[0]) {
    return findStatusCodeId[0]
      .slice(15, findStatusCodeId[0].length - 1)
      .split(`,`)
  }

  return null
}

const eventTypeFromFilter = filter => {
  if (!filter) {
    return null
  }

  const eventTypeIdRegex = /;?eventTypeId=in=\((?<eventTypeId>\S+)(.\);?)/gi
  return trim(get(eventTypeIdRegex.exec(filter), `groups.eventTypeId`, ``), `;`)
    .split(`,`)
    .map(item => parseInt(item, 10))
}

const eventStatusFromFilter = filter => {
  if (!filter) {
    return null
  }

  const statusCodeRegex = /;?statusCode=in=\((?<statusCode>\S+)(.\);?)/gi
  return trim(get(statusCodeRegex.exec(filter), `groups.statusCode`, ``), `;`)
    .split(`,`)
    .map(item => item)
}

// Get initial filters
const getResourceFilter = filter => {
  if (filter) {
    const removeQ = filter.slice(-1) === `?` ? filter.slice(0, -1) : filter
    const typeVal = typeQueryToValue(removeQ)
    const resTypeQuery = typeVal
      ? `resourceTypeId=in=(${typeVal.join(`,`)})`
      : ``
    const nameVal = nameQueryToValue(removeQ)
    const resNameQuery = nameVal
      ? `${typeVal ? `;` : ``}name==*${nameVal}*`
      : ``
    return resTypeQuery.concat(resNameQuery)
  }
  return undefined
}

const getEventFilter = filter => {
  if (filter) {
    const removeQ = filter.slice(-1) === `?` ? filter.slice(0, -1) : filter
    const typeVal = eventTypeQueryToValue(removeQ)
    const eventTypeQuery = typeVal
      ? `eventTypeId=in=(${typeVal.join(`,`)})`
      : ``
    const statusVal = statusCodeQueryToValue(filter)
    const statusQuery = statusVal
      ? `${typeVal ? `;` : ``}statusCode=in=(${statusVal.join(`,`)})`
      : ``
    const customVal = eventCustomFieldQueryToValue(filter)
    const customFieldQuery = customVal
      ? `${typeVal ? `;` : ``}customField=='*${customVal}*'`
      : null

    return eventTypeQuery.concat(statusQuery).concat(customFieldQuery || [])
  }
  return undefined
}

export default hocInterface(
  {
    injectProps: {
      planId: PropTypes.string,
      calendarStartTime: PropTypes.any,
      calendarEndTime: PropTypes.any,
      calendarScale: PropTypes.any,
      location: PropTypes.any,
      calendarFilter: PropTypes.any,
    },
    exposeProps: [
      `updateRecords`,
      `calendarData`,
      `calendarMeta`,
      `toggleOrder`,
      `orderBy`,
      `loadNextPage`,
      `filterCalendarBy`,
      `resourceTypeIdFilter`,
      `eventTypeIdFilter`,
      `statusCodeFilter`,
      `eventCustomFieldFilter`,
      `resourceNameFilter`,
      `addCalendarEvent`,
      `updateCalendarEvent`,
      `removeCalendarEvent`,
    ],
  },
  compose(
    connect(
      state => ({
        calendarData: selectCalendarData(state),
        calendarMeta: selectCalendarMeta(state),
      }),
      {
        loadCalendar,
        initCalendar,
        addCalendarEvent: addEvent,
        updateCalendarEvent: updateEvent,
        removeCalendarEvent: removeEvent,
      },
    ),

    withStateHandlers(
      ({
        calendarStartTime,
        calendarEndTime,
        calendarScale,
        calendarFilter,
      }) => ({
        calendarQuery: {
          startDateTime: moment(calendarStartTime)
            .startOf(SCALE_CODES[calendarScale])
            .valueOf(),
          endDateTime: moment(calendarEndTime)
            .endOf(SCALE_CODES[calendarScale])
            .valueOf(),
          offset: 0,
          limit: DEFAULT_PAGE_HEIGHT,
          orderBy: ORDER_ASC,
          zone: `Europe/Moscow`,
          resourceQuery: getResourceFilter(calendarFilter) || undefined,
          eventQuery: getEventFilter(calendarFilter),
          resourceTypeId: valueFromFilter(calendarFilter),
          eventTypeId: eventTypeFromFilter(calendarFilter),
          statusCode: eventStatusFromFilter(calendarFilter),
        },
      }),
      {
        setCalendarQuery: ({ calendarQuery }) => transform => ({
          calendarQuery: transform(calendarQuery),
        }),
      },
    ),

    BaseComponent => props => {
      const {
        planId,
        calendarQuery,
        initCalendar,
        loadCalendar,
        setCalendarQuery,
        calendarStartTime,
        calendarEndTime,
        calendarScale,
      } = props
      const prevPlanId = usePrevious(planId)
      const prevCalendarQuery = usePrevious(calendarQuery)
      const {
        handlers: { setQuery },
      } = useQueryState()

      useEffect(() => {
        setCalendarQuery(currentQuery => ({
          ...currentQuery,
          offset: 0,
          startDateTime: moment(calendarStartTime)
            .startOf(SCALE_CODES[calendarScale])
            .valueOf(),
          endDateTime: moment(calendarEndTime)
            .endOf(SCALE_CODES[calendarScale])
            .valueOf(),
        }))
      }, [calendarStartTime, calendarEndTime, calendarScale])

      useEffect(() => {
        const isPlanSame = prevPlanId === planId
        const isQuerySame = prevCalendarQuery === calendarQuery
        const isFirstLoad = !prevCalendarQuery

        if ((!isPlanSame || (!isQuerySame && isFirstLoad)) && calendarQuery) {
          initCalendar({ planId, query: calendarQuery })
        } else if (isPlanSame && !isQuerySame && !isFirstLoad) {
          // Параметры при изменении корорых, нужно перезагрузить календарь
          const propsCausingCalendarInit = [
            `startDateTime`,
            `endDateTime`,
            `orderBy`,
            `resourceQuery`,
            `eventQuery`,
          ]

          const shouldInit = propsCausingCalendarInit.some(
            propName => prevCalendarQuery[propName] !== calendarQuery[propName],
          )

          if (shouldInit) {
            initCalendar({ planId, query: calendarQuery })
          } else {
            loadCalendar({ planId, query: calendarQuery })
          }
        }
      }, [planId, calendarQuery])

      const [resourceName, setResourceNameFilter] = useState(
        nameQueryToValue(calendarQuery.resourceQuery),
      )
      const [resourceType, setResourceTypeFilter] = useState(
        typeQueryToValue(calendarQuery.resourceQuery),
      )
      const [eventStatusFilter, setEventStatusFilter] = useState(
        statusCodeQueryToValue(calendarQuery.eventQuery),
      )
      const [eventTypeFilter, setEventTypeFilter] = useState(
        eventTypeQueryToValue(calendarQuery.eventQuery),
      )
      const [eventCustomFieldFilter, setEventCustomFieldFilter] = useState(
        eventCustomFieldQueryToValue(calendarQuery.eventQuery),
      )

      useEffect(() => {
        const resourceFilter = resourceTypeIdToQuery(resourceType)
          .concat(resourceNameToQuery(resourceName))
          .filter(item => !!item)
          .join(`;`)
        const eventFilter = eventToQuery(eventTypeFilter)
          .concat(statusToQuery(eventStatusFilter))
          .concat(eventCustomFieldToQuery(eventCustomFieldFilter))
          .filter(item => !!item)
          .join(`;`)
        setCalendarQuery(currentQuery => ({
          ...currentQuery,
          resourceQuery: resourceFilter,
          eventQuery: eventFilter,
          offset: 0,
          resourceName,
          eventCustomFieldFilter,
          resourceTypeId: resourceType,
          eventTypeId: eventTypeFilter,
          statusCode: eventStatusFilter,
        }))
        setQuery({
          filter: resourceFilter.concat(
            resourceFilter ? `?${eventFilter}` : eventFilter,
          ),
        })
      }, [
        resourceName,
        resourceType,
        eventStatusFilter,
        eventTypeFilter,
        eventCustomFieldFilter,
      ])

      return (
        <BaseComponent
          {...props}
          setFilter={setQuery}
          // TODO: DELETE
          filterByResourceName={setResourceNameFilter}
          filterByResourceType={setResourceTypeFilter}
          filterCalendarBy={{
            setResourceNameFilter,
            setResourceTypeFilter,
            setEventStatusFilter,
            setEventTypeFilter,
            setEventCustomFieldFilter,
          }}
        />
      )
    },

    withHandlers({
      updateRecords: ({
        loadCalendar,
        calendarQuery,
        planId,
      }) => resourceUuids => {
        const { startDateTime, endDateTime, zone } = calendarQuery || {}
        loadCalendar({
          planId,
          query: {
            startDateTime,
            endDateTime,
            zone,
            resourceQuery: `uuid=in=(${resourceUuids
              .map(uuid => `"${uuid}"`)
              .join()})`,
            // eventQuery: `eventFilter`,
          },
          keepCount: true,
        })
      },
      loadNextPage: ({ setCalendarQuery, calendarMeta }) => () => {
        setCalendarQuery(currentQuery => {
          const { offset } = currentQuery
          const isInitialized = offset !== undefined

          if (isInitialized) {
            const isLastPage =
              offset + DEFAULT_PAGE_HEIGHT >= calendarMeta.count
            if (!isLastPage) {
              return {
                ...currentQuery,
                offset: offset + DEFAULT_PAGE_HEIGHT,
              }
            }
          }
          return currentQuery
        })
      },
      toggleOrder: ({ setCalendarQuery }) => () => {
        setCalendarQuery(currentQuery => ({
          ...currentQuery,
          orderBy: currentQuery.orderBy === ORDER_ASC ? ORDER_DESC : ORDER_ASC,
          offset: 0,
        }))
      },
    }),
    withProps(({ calendarQuery }) => ({
      orderBy: calendarQuery ? calendarQuery.orderBy : null,
      resourceTypeIdFilter: get(calendarQuery, `resourceTypeId`) || [],
      resourceNameFilter: get(calendarQuery, `resourceName`) || [],
      eventTypeIdFilter: get(calendarQuery, `eventTypeId`) || [],
      statusCodeFilter: get(calendarQuery, `statusCode`) || [],
      eventCustomFieldFilter:
        get(calendarQuery, `eventCustomFieldFilter`) || null,
    })),
  ),
)
